import { defineMessages } from 'react-intl-next';

export const sharedi18n = defineMessages({
	maxLength: {
		id: 'content-state.status.create.status.max.length',
		description: 'Helper message below text field which tells user the max length is 20',
		defaultMessage: 'Max length of 20',
	},
	requiredErrorMessage: {
		id: 'content-state.status.maker.error.message',
		description:
			'Error message that appears below text field if user does not enter anything in the text field and tries to submit',
		defaultMessage: 'Required',
	},
	emptyStatusFlagTitle: {
		id: 'content-state.status.empty.status.flag.title',
		description:
			'Title in warning flag that shows if user tries to create a status with only empty/white space',
		defaultMessage: 'Your status can’t be saved',
	},
	emptyStatusFlagDescription: {
		id: 'content-state.status.empty.status.flag.description',
		description:
			'Description in warning flag that shows if user tries to create a status with only empty/white space',
		defaultMessage: 'Statuses must contain symbols or alphanumeric characters.',
	},
	verifiedRestricted: {
		id: 'content-state.verified-restricted',
		description:
			'Message in the tooltip when user hovers over content state when the content state is verified and can only be altered by page owners or space admins.',
		defaultMessage: 'This content is verified. Only its owner or an admin can change its status.',
	},
	verifiedRestrictedRbac: {
		id: 'content-state.verified-restricted-rbac',
		description:
			'Message in the tooltip when user hovers over content state when the content state is verified and can only be altered by someone with permission to manage all content in the space.',
		defaultMessage:
			'This content is verified. Only its owner or someone with permission to manage all content in the space can change its status.',
	},
	pageStatus: {
		id: 'content-state.page-status',
		description:
			'Message in the tooltip when user hovers over content state that explains the component is the page status.',
		defaultMessage: 'Status',
	},
	verifiedContentSpotlightTitle: {
		id: 'content-state.verified-content.spotlight.title',
		description: 'Title in the spotlight card for verified content automation discovery',
		defaultMessage: 'Verified Content',
	},
	verifiedContentSpotlightAction: {
		id: 'content-state.verified-content.spotlight.action',
		description: 'Primary action button text in the spotlight card for setting up automation',
		defaultMessage: 'Set up automation',
	},
	newSpotlightTitle: {
		id: 'content-state.automation-discovery.verified-content.title',
		description: 'Title in the spotlight card for verified content automation discovery',
		defaultMessage: 'Want to manage your verified pages?',
	},
	newSpotlightBody: {
		id: 'content-state.automation-discovery.verified-content.body',
		description: 'Body text in the spotlight card for verified content automation discovery',
		defaultMessage: 'Use Confluence automation to schedule reviews for verified content.',
	},
	newSpotlightCta: {
		id: 'content-state.automation-discovery.manual-trigger.cta.text',
		description: 'Primary action button text for building an automation rule',
		defaultMessage: 'Build rule',
	},
	newSpotlightDismiss: {
		id: 'content-state.automation-discovery.manual-trigger.dismiss',
		description: 'Dismiss button text in the spotlight card',
		defaultMessage: 'Done',
	},
});
